import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Warms the page chunks for routes reached via `router.push`, which — unlike
 * `next/link` — never prefetches on its own. No-op in development.
 */
export function useRoutePrefetch(routes: string[]): void {
  const router = useRouter();
  const routesKey = routes.join('|');

  useEffect(() => {
    routesKey
      .split('|')
      .filter(Boolean)
      .forEach((route) => {
        router.prefetch(route).catch(() => {});
      });
  }, [router, routesKey]);
}
